import { rehype } from 'rehype'; // @ts-ignore

import rehypePrism from '@mapbox/rehype-prism';
export var processHtml = function processHtml(html) {
  return rehype().data('settings', {
    fragment: true
  }).use(rehypePrism, {
    ignoreMissing: true
  }).processSync("" + html).toString();
}; // function htmlEncode(html: string) {
//   const temp = document.createElement ('div');
//   (temp.textContent !== undefined) ? (temp.textContent = html) : (temp.innerText = html);
//   const output = temp.innerHTML;
//   return output;
// }

export function htmlEncode(sHtml) {
  return sHtml.replace(/[<>&"]/g, function (c) {
    return {
      '<': '&lt;',
      '>': '&gt;',
      '&': '&amp;',
      '"': '&quot;'
    }[c];
  });
}
export function stopPropagation(e) {
  e.stopPropagation();
  e.preventDefault();
}